/**
 * 这里存放mobx store中处理数据的通用逻辑
 * @providesModule ModelUtilsX
 */
import { isObservableArray} from 'mobx';

/**
 * 判断mobx数据是否是空Array
 * @param arr
 */
export function isValidArray(arr) {
    // 如果为undefined、0、null、''等空值，则直接返回false
    if (!arr) {
        return false;
    }

    return isArray(arr) && arr.length > 0;
}

/**
 * 是否是array
 * @param arr
 * @return {thing is IObservableArray<any>}
 */
export function isArray(arr) {
    return Array.isArray(arr) || isObservableArray(arr);
}
